export default "__VITE_ASSET__3dYRQW2c__"